import { Ref, ComputedRef, InjectionKey } from 'vue';
import { Service } from '@/entities/services/types';

export type ServiceInject = {
  service: Ref<Service | undefined>;
  isCertifiedVolta: ComputedRef<boolean>;
  isVoltaExpress: ComputedRef<boolean>;
  isVoltaPlus: ComputedRef<boolean>;
}
export const serviceInjectionKey = Symbol('service') as InjectionKey<ServiceInject>;
